import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getReceptaclesTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RECEPTACLES_PREDES_RESDES_ANALYSIS.id,
    mainReportId: ReportDefinitions.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.id,
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}
export default (data) => {
  const {
    DateTimeColumn,
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new DateTimeColumn('Despatch closed', 'predes.despatchCloseDate'),
        new TextColumn('Origin IMPC', 'predes.originImpc'),
        new TextColumn('Destination IMPC', 'predes.destinationImpc'),
        new NavigationColumn(new NonZeroNumberColumn('Receptacles', 'predes.receptaclesCount'), getReceptaclesTabNavigationProps),
        new NavigationColumn(new NonZeroNumberColumn('IB', 'predes.matchingType'), getReceptaclesTabNavigationProps),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('No response', 'resdes.noResponse'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% No response', 'resdes.noResponsePercentage'),
        new NavigationColumn(new NonZeroNumberColumn('IB', 'resdes.match'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% IB', 'resdes.matchPercentage'),
        new NavigationColumn(new NonZeroNumberColumn('Non-IB', 'resdes.noMatch'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% Non-IB', 'resdes.noMatchPercentage'),
        new TextColumn('Receptacle types', 'resdes.types'),
        new NavigationColumn(new NonZeroNumberColumn('IB, PREDES non-IB', 'resdes.matchWithoutPredes'), getReceptaclesTabNavigationProps),
        new NonZeroPercentageColumn('% IB, PREDES non-IB', 'resdes.matchWithoutPredesPercentage'),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Receptacle types', 'predes.types'),
      ],
    },
  ];
};
